<template>
  <div>
    <div v-if="!loading">
      <Lynx-Title :text="form.name" v-if="form.id && form.name" v-once />
      <Lynx-Title text="Adicionar Layout" v-else />
      <form class="flex flex-wrap" @submit.prevent="handleRegister">
        <label
          class="w-full block px-1 md:w-5/12 tracking-wide text-gray-700 text-xs"
        >
          <Lynx-Label label="Nome" />
          <Lynx-Input
            placeholder="Insira o nome"
            :error="$v.form.name.$error"
            v-model.trim="$v.form.name.$model"
            :validator="$v.form.name"
            :validations-message="validationsMessage.form.name"
          />
        </label>
        <label
          class="w-full block px-1 md:w-5/12 tracking-wide text-gray-700 text-xs"
        >
          <Lynx-Label label="Categoria" />
          <Lynx-Select
            v-model.trim="form.categoryId"
            :error="$v.form.categoryId.$error"
            :options="categories"
            :validator="$v.form.categoryId"
            :validations-message="validationsMessage.form.categoryId"
          />
        </label>
        <label
          class="w-full block px-1 md:w-1/6 tracking-wide text-gray-700 text-xs"
        >
          <Lynx-Label label="Logo Habilitada?" />
          <div class="flex items-center h-10">
            <b-switch size="is-medium" v-model="form.logoEnabled" />
          </div>
        </label>
        <label
          class="w-full block px-1 md:w-1/4 tracking-wide text-gray-700 text-xs"
        >
          <Lynx-Label label="Cor primária" />
          <div class="layout-color-picker-card">
            <input
              class="layout-color-native-picker"
              type="color"
              :value="toNativeColor(form.colorPrimary)"
              @input="updateColor('colorPrimary', $event.target.value)"
            />
          </div>
          <div class="layout-color-picker-row">
            <div
              class="layout-color-preview"
              :style="{ backgroundColor: toRgbaColor(form.colorPrimary) }"
            />
            <div class="layout-color-picker-content">
              <div class="layout-color-code">{{ form.colorPrimary }}</div>
              <div class="layout-color-channel-row">
                <span class="layout-color-channel-label">R</span>
                <input
                  class="layout-color-channel"
                  type="number"
                  min="0"
                  max="255"
                  :value="getColorChannel(form.colorPrimary, 'r')"
                  @input="
                    updateColorChannel(
                      'colorPrimary',
                      'r',
                      $event.target.value
                    )
                  "
                />
              </div>
              <div class="layout-color-channel-row">
                <span class="layout-color-channel-label">G</span>
                <input
                  class="layout-color-channel"
                  type="number"
                  min="0"
                  max="255"
                  :value="getColorChannel(form.colorPrimary, 'g')"
                  @input="
                    updateColorChannel(
                      'colorPrimary',
                      'g',
                      $event.target.value
                    )
                  "
                />
              </div>
              <div class="layout-color-channel-row">
                <span class="layout-color-channel-label">B</span>
                <input
                  class="layout-color-channel"
                  type="number"
                  min="0"
                  max="255"
                  :value="getColorChannel(form.colorPrimary, 'b')"
                  @input="
                    updateColorChannel(
                      'colorPrimary',
                      'b',
                      $event.target.value
                    )
                  "
                />
              </div>
              <div class="layout-color-alpha-row">
                <span class="layout-color-alpha-label">Transparência</span>
                <input
                  class="layout-color-alpha"
                  type="range"
                  min="0"
                  max="100"
                  :value="toAlphaPercent(form.colorPrimary)"
                  @input="updateAlpha('colorPrimary', $event.target.value)"
                />
                <span class="layout-color-alpha-value">
                  {{ toAlphaPercent(form.colorPrimary) }}%
                </span>
              </div>
            </div>
          </div>
        </label>
        <label
          class="w-full block px-1 md:w-1/4 tracking-wide text-gray-700 text-xs"
        >
          <Lynx-Label label="Cor secundária" />
          <div class="layout-color-picker-card">
            <input
              class="layout-color-native-picker"
              type="color"
              :value="toNativeColor(form.colorSecondary)"
              @input="updateColor('colorSecondary', $event.target.value)"
            />
          </div>
          <div class="layout-color-picker-row">
            <div
              class="layout-color-preview"
              :style="{ backgroundColor: toRgbaColor(form.colorSecondary) }"
            />
            <div class="layout-color-picker-content">
              <div class="layout-color-code">{{ form.colorSecondary }}</div>
              <div class="layout-color-channel-row">
                <span class="layout-color-channel-label">R</span>
                <input
                  class="layout-color-channel"
                  type="number"
                  min="0"
                  max="255"
                  :value="getColorChannel(form.colorSecondary, 'r')"
                  @input="
                    updateColorChannel(
                      'colorSecondary',
                      'r',
                      $event.target.value
                    )
                  "
                />
              </div>
              <div class="layout-color-channel-row">
                <span class="layout-color-channel-label">G</span>
                <input
                  class="layout-color-channel"
                  type="number"
                  min="0"
                  max="255"
                  :value="getColorChannel(form.colorSecondary, 'g')"
                  @input="
                    updateColorChannel(
                      'colorSecondary',
                      'g',
                      $event.target.value
                    )
                  "
                />
              </div>
              <div class="layout-color-channel-row">
                <span class="layout-color-channel-label">B</span>
                <input
                  class="layout-color-channel"
                  type="number"
                  min="0"
                  max="255"
                  :value="getColorChannel(form.colorSecondary, 'b')"
                  @input="
                    updateColorChannel(
                      'colorSecondary',
                      'b',
                      $event.target.value
                    )
                  "
                />
              </div>
              <div class="layout-color-alpha-row">
                <span class="layout-color-alpha-label">Transparência</span>
                <input
                  class="layout-color-alpha"
                  type="range"
                  min="0"
                  max="100"
                  :value="toAlphaPercent(form.colorSecondary)"
                  @input="updateAlpha('colorSecondary', $event.target.value)"
                />
                <span class="layout-color-alpha-value">
                  {{ toAlphaPercent(form.colorSecondary) }}%
                </span>
              </div>
            </div>
          </div>
        </label>
        <label
          class="w-full block px-1 md:w-1/4 tracking-wide text-gray-700 text-xs"
        >
          <Lynx-Label label="Cor do texto" />
          <div class="layout-color-picker-card">
            <input
              class="layout-color-native-picker"
              type="color"
              :value="toNativeColor(form.colorText)"
              @input="updateColor('colorText', $event.target.value)"
            />
          </div>
          <div class="layout-color-picker-row">
            <div
              class="layout-color-preview"
              :style="{ backgroundColor: toRgbaColor(form.colorText) }"
            />
            <div class="layout-color-picker-content">
              <div class="layout-color-code">{{ form.colorText }}</div>
              <div class="layout-color-channel-row">
                <span class="layout-color-channel-label">R</span>
                <input
                  class="layout-color-channel"
                  type="number"
                  min="0"
                  max="255"
                  :value="getColorChannel(form.colorText, 'r')"
                  @input="
                    updateColorChannel('colorText', 'r', $event.target.value)
                  "
                />
              </div>
              <div class="layout-color-channel-row">
                <span class="layout-color-channel-label">G</span>
                <input
                  class="layout-color-channel"
                  type="number"
                  min="0"
                  max="255"
                  :value="getColorChannel(form.colorText, 'g')"
                  @input="
                    updateColorChannel('colorText', 'g', $event.target.value)
                  "
                />
              </div>
              <div class="layout-color-channel-row">
                <span class="layout-color-channel-label">B</span>
                <input
                  class="layout-color-channel"
                  type="number"
                  min="0"
                  max="255"
                  :value="getColorChannel(form.colorText, 'b')"
                  @input="
                    updateColorChannel('colorText', 'b', $event.target.value)
                  "
                />
              </div>
              <div class="layout-color-alpha-row">
                <span class="layout-color-alpha-label">Transparência</span>
                <input
                  class="layout-color-alpha"
                  type="range"
                  min="0"
                  max="100"
                  :value="toAlphaPercent(form.colorText)"
                  @input="updateAlpha('colorText', $event.target.value)"
                />
                <span class="layout-color-alpha-value">
                  {{ toAlphaPercent(form.colorText) }}%
                </span>
              </div>
            </div>
          </div>
        </label>
        <div class="flex flex-wrap">
          <div
            v-for="layoutModel in layoutModels"
            :key="layoutModel.id"
            class="flex"
          >
            <div
              class="w-full block px-1 tracking-wide text-gray-700 text-xs pb-8"
            >
              <Lynx-Label :label="`${layoutModel.name}`" />
              <UploadFile
                @upload="onFileOk"
                :fileData="fileData"
                :loading="loadingButton"
                :defaultFile="getLayoutModelFile(layoutModel.slug)"
                :slug="layoutModel.slug"
                isEdit
                hideButtons
              />
            </div>
          </div>
        </div>
        <div class="flex flex-1 justify-between">
          <router-link :to="{ name: 'layouts.index' }">
            <Lynx-Button size="is-normal" class="is-light" text="Voltar" />
          </router-link>
          <Lynx-Button
            size="is-normal"
            class="is-success"
            type="submit"
            text="Salvar"
            :loading="loadingButton"
          />
        </div>
      </form>
    </div>
    <Lynx-OverlaySpinner v-else :loading="loading" />
  </div>
</template>

<script>
import {
  layoutsCreateRequest,
  layoutsUpdateRequest,
  layoutsShowRequest,
  layoutModelsRequest,
} from "../../services/requests/layouts";

import { getFileByPathAndToken } from "../../services/requests/files";
import { required } from "vuelidate/lib/validators";
import { convertBase64, arrayBufferToFile } from "../../utils/base64";
import UploadFile from "../../components/shared/UploadFile";
import { mapGetters } from "vuex";
import { categoriesRequest } from "../../services/requests/categories";

export default {
  name: "LayoutsCreate",
  components: { UploadFile },
  data() {
    return {
      layoutId: this.$route.params.id ?? null,
      fileId: null,
      categories: [],
      layoutModels: [],
      layout_models: {
        feed_face_insta: { fileId: null, file: null, isDirty: false },
        stories_status_reels_insta: {
          fileId: null,
          file: null,
          isDirty: false,
        },
        tv_horizontal: { fileId: null, file: null, isDirty: false },
        a4_vertical: { fileId: null, file: null, isDirty: false },
        a4_horizontal: { fileId: null, file: null, isDirty: false },
      },
      form: {
        name: null,
        categoryId: null,
        colorPrimary: "#FFFFFFFF",
        colorSecondary: "#FFFFFFFF",
        colorText: "#FF0000FF",
        logoEnabled: true,
      },
      uploadSuccess: false,
      fileData: {
        type: "JPG, JPEG, PNG, GIF, BMP ou WEBP",
        mimeType: [
          "image/jpeg",
          "image/jpg",
          "image/png",
          "image/gif",
          "image/bmp",
          "image/webp",
        ],
      },
      loading: false,
      loadingButton: false,
      validationsMessage: {
        form: {
          name: {
            required: "Insira o nome completo",
          },
          categoryId: {
            required: "Escolha a categoria",
          },
        },
        layout_models: {
          feed_face_insta: {
            file: {
              required: "Insira a imagem para Feed, Face, Insta",
            },
          },
          stories_status_reels_insta: {
            file: {
              required: "Insira a imagem para Stories, Status, Reels, Insta",
            },
          },
          tv_horizontal: {
            file: {
              required: "Insira a imagem para TV Horizontal",
            },
          },
          a4_vertical: {
            file: {
              required: "Insira a imagem para TV Vertical",
            },
          },
          a4_horizontal: {
            file: {
              required: "Insira a imagem para A4 Horizontal",
            },
          },
        },
      },
    };
  },
  validations() {
    return {
      form: {
        name: { required },
        categoryId: { required },
      },
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  methods: {
    toNativeColor(color) {
      if (!color || typeof color !== "string") {
        return "#000000";
      }

      if (color.length === 9) {
        return color.slice(0, 7);
      }

      return color;
    },
    updateColor(field, value) {
      this.form[field] = `${value.toUpperCase()}${this.getAlphaHex(
        this.form[field]
      )}`;
    },
    getAlphaHex(color) {
      if (!color || typeof color !== "string" || color.length !== 9) {
        return "FF";
      }

      return color.slice(7, 9).toUpperCase();
    },
    toAlphaPercent(color) {
      const alpha = parseInt(this.getAlphaHex(color), 16);
      return Math.round((alpha / 255) * 100);
    },
    updateAlpha(field, value) {
      const alpha = Math.round((Number(value) / 100) * 255)
        .toString(16)
        .padStart(2, "0")
        .toUpperCase();
      const color = this.toNativeColor(this.form[field]).toUpperCase();

      this.form[field] = `${color}${alpha}`;
    },
    getColorChannel(color, channel) {
      const nativeColor = this.toNativeColor(color).replace("#", "");
      const channels = {
        r: nativeColor.slice(0, 2),
        g: nativeColor.slice(2, 4),
        b: nativeColor.slice(4, 6),
      };

      return parseInt(channels[channel] || "00", 16);
    },
    updateColorChannel(field, channel, value) {
      const channels = {
        r: this.getColorChannel(this.form[field], "r"),
        g: this.getColorChannel(this.form[field], "g"),
        b: this.getColorChannel(this.form[field], "b"),
      };

      channels[channel] = Math.min(255, Math.max(0, Number(value) || 0));

      const color = ["r", "g", "b"]
        .map((key) => channels[key].toString(16).padStart(2, "0"))
        .join("")
        .toUpperCase();

      this.form[field] = `#${color}${this.getAlphaHex(this.form[field])}`;
    },
    toRgbaColor(color) {
      const alpha = this.toAlphaPercent(color) / 100;

      return `rgba(${this.getColorChannel(color, "r")}, ${this.getColorChannel(
        color,
        "g"
      )}, ${this.getColorChannel(color, "b")}, ${alpha})`;
    },
    ensureLayoutModelEntry(slug) {
      if (!slug || this.layout_models[slug]) {
        return;
      }

      this.$set(this.layout_models, slug, {
        fileId: null,
        file: null,
        isDirty: false,
      });
    },
    getErrors(error) {
      const response = error && error.response;
      const data = (response && response.data) || {};
      const validationErrors =
        data.errors && typeof data.errors === "object"
          ? Object.values(data.errors)
          : [];
      let errors = validationErrors.reduce(
        (messages, item) => messages.concat(item),
        []
      );

      if (response && response.status === 413) {
        errors = ["O arquivo selecionado excede o limite permitido."];
      } else if (!errors.length && (data.message || data.error)) {
        errors = [data.message || data.error];
      } else if (!errors.length) {
        errors = ["Ocorreu um erro ao salvar o layout."];
      }

      const message = errors.map((message) => `<li>${message}</li>`).join("");

      this.$buefy.dialog.alert({
        title: "Não foi possível salvar o Layout",
        message: `<ul>${message}</ul>`,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true,
      });
    },
    async fetchLayout() {
      if (this.layoutId) {
        await layoutsShowRequest(this.layoutId)
          .then(async (res) => {
            const data = res.data.data;
            this.fileId = data.file?.id;
            this.form = {
              name: data.name,
              categoryId: data.category_id,
              colorPrimary: data.color_primary || "#FFFFFFFF",
              colorSecondary: data.color_secondary || "#FFFFFFFF",
              colorText: data.color_text || "#FF0000FF",
              logoEnabled: data.logo_enabled !== false,
            };
            if (data.model_layouts.length > 0) {
              for (const modelLayout of data.model_layouts) {
                try {
                  this.ensureLayoutModelEntry(modelLayout.slug);
                  const fileId = modelLayout.pivot.file
                    ? modelLayout.pivot.file.id
                    : null;
                  const file = modelLayout.pivot.file
                    ? await getFileByPathAndToken(
                        modelLayout.pivot.file.path,
                        this.getToken
                      )
                    : null;

                  if (file) {
                    this.layout_models[modelLayout.slug].fileId = fileId;
                    this.layout_models[modelLayout.slug].file =
                      arrayBufferToFile(
                        file.data,
                        modelLayout.pivot.file.extension,
                        modelLayout.pivot.file.name
                      );
                  } else {
                    if (this.fileId && modelLayout.slug === "feed_face_insta") {
                      await getFileByPathAndToken(
                        data.file.path,
                        this.getToken
                      ).then((file) => {
                        this.layout_models[modelLayout.slug].file =
                          arrayBufferToFile(
                            file.data,
                            data.file.extension,
                            data.file.name
                          );
                      });
                    }
                  }
                } catch (error) {
                  this.getErrors(error);
                }
              }
            } else if (this.fileId) {
              await getFileByPathAndToken(data.file.path, this.getToken).then(
                (file) => {
                  this.layout_models["feed_face_insta"].file =
                    arrayBufferToFile(
                      file.data,
                      data.file.extension,
                      data.file.name
                    );
                }
              );
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((err) => {
            this.$router.push({ name: "layouts.index" });
            this.$snack.error("Layout não encontrado");
          });
      }
    },
    getLayoutModelFile(slug) {
      if (this.layout_models && this.layout_models[slug]) {
        return this.layout_models[slug].file;
      }
      return null;
    },
    async onFileOk(file) {
      this.ensureLayoutModelEntry(file.slug);
      this.layout_models[file.slug].file = file;
      this.layout_models[file.slug].isDirty = true;
    },
    async handleRegister() {
      await this.$v.$touch();
      if (this.$v.form.$invalid) {
        this.$snack.error("Preencha corretamente o formulário");
        return;
      }

      if (
        !this.form.colorPrimary ||
        !this.form.colorSecondary ||
        !this.form.colorText
      ) {
        this.$snack.error("Preencha todas as cores do Layout");
        return;
      }

      if (!this.form.role) {
        this.form.role = "customer";
      }

      const dataForSubmit = {
        id: this.layoutId,
        name: this.form.name,
        category_id: this.form.categoryId,
        color_primary: this.form.colorPrimary,
        color_secondary: this.form.colorSecondary,
        color_text: this.form.colorText,
        logo_enabled: this.form.logoEnabled,
        layout_models: {},
      };

      for (const key in this.layout_models) {
        // eslint-disable-next-line no-prototype-builtins
        if (this.layout_models.hasOwnProperty(key)) {
          const layout = this.layout_models[key];
          if (!layout.file || (this.layoutId && !layout.isDirty)) {
            continue;
          }
          await convertBase64(layout.file)?.then((base64) => {
            dataForSubmit.layout_models[key] = {};
            dataForSubmit.layout_models[key].file = {
              id: layout.fileId ?? null,
              label: "layoutModelLayout",
              name: layout.file.name,
              base64,
            };
          });
        }
      }

      if (
        !this.layoutId &&
        Object.keys(dataForSubmit.layout_models).length === 0
      ) {
        this.$snack.error("Escolha pelo menos uma imagem de modelo");
        return;
      }

      this.loadingButton = true;
      if (!this.layoutId) {
        await layoutsCreateRequest(dataForSubmit)
          // eslint-disable-next-line no-unused-vars
          .then((res) => {
            this.uploadSuccess = true;
            this.$snack.success("Layout salvo com sucesso");
            this.$router.push({ name: "layouts.index" });
          })
          .catch((error) => {
            this.getErrors(error);
          })
          .finally(() => (this.loadingButton = false));
      } else {
        await layoutsUpdateRequest(dataForSubmit)
          // eslint-disable-next-line no-unused-vars
          .then((res) => {
            this.$snack.success("Layout salvo com sucesso");
            this.$router.push({ name: "layouts.index" });
          })
          .catch((error) => {
            this.getErrors(error);
          })
          .finally(() => (this.loadingButton = false));
      }
    },
    async fetchCategories() {
      return (
        categoriesRequest()
          .then((res) => {
            this.categories = res.data.data;
          })
          // eslint-disable-next-line no-unused-vars
          .catch((err) => {
            this.$snack.error({
              text: "Ocorreu um erro, tente novamente mais tarde",
              button: "X",
            });
          })
      );
    },
    fetchLayoutModels() {
      return layoutModelsRequest()
        .then(async (res) => {
          this.layoutModels = res.data.data;
          this.layoutModels.forEach((layoutModel) => {
            this.ensureLayoutModelEntry(layoutModel.slug);
          });
        })
        .catch(() => {
          this.$snack.error({
            text: "Ocorreu um erro ao carregar os modelos do layout",
            button: "X",
          });
        });
    },
  }, // methods
  async mounted() {
    this.loading = true;
    try {
      await Promise.all([
        this.fetchCategories(),
        this.fetchLayout(),
        this.fetchLayoutModels(),
      ]);
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style lang="scss">
.layout-color-picker-row {
  display: block;
  gap: 0.75rem;
  padding: 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.9rem;
  background: #ffffff;
  margin-top: 0.75rem;
}

.layout-color-picker-card {
  overflow: hidden;
  padding: 0.4rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.9rem;
  background: #ffffff;
}

.layout-color-native-picker {
  display: block;
  width: 100%;
  height: 92px;
  padding: 0;
  border: 0;
  border-radius: 0.7rem;
  background: transparent;
  cursor: pointer;
  overflow: hidden;
}

.layout-color-native-picker::-webkit-color-swatch-wrapper {
  padding: 0;
}

.layout-color-native-picker::-webkit-color-swatch {
  border: 0;
  border-radius: 0.7rem;
}

.layout-color-native-picker::-moz-color-swatch {
  border: 0;
  border-radius: 0.7rem;
}

.layout-color-picker-content {
  flex: 1;
  min-width: 0;
}

.layout-color-preview {
  display: none;
  width: 64px;
  min-width: 64px;
  height: 64px;
  border: 1px solid #d1d5db;
  border-radius: 0.85rem;
  background-image: linear-gradient(45deg, #e5e7eb 25%, transparent 25%),
    linear-gradient(-45deg, #e5e7eb 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #e5e7eb 75%),
    linear-gradient(-45deg, transparent 75%, #e5e7eb 75%);
  background-position: 0 0, 0 8px, 8px -8px, -8px 0;
  background-size: 16px 16px;
}

.layout-color-code {
  min-height: 40px;
  display: flex;
  align-items: center;
  padding: 0 0.75rem;
  border-radius: 0.75rem;
  background: #f3f4f6;
  color: #374151;
  font-size: 0.78rem;
  font-family: monospace;
  overflow: hidden;
}

.layout-color-channel-row,
.layout-color-alpha-row {
  display: grid;
  grid-template-columns: 24px 72px;
  align-items: center;
  gap: 0.45rem;
  margin-top: 0.5rem;
}

.layout-color-alpha-row {
  grid-template-columns: 92px minmax(0, 1fr) 42px;
}

.layout-color-channel-label,
.layout-color-alpha-label {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 999px;
  background: #e5e7eb;
  color: #374151;
  font-size: 0.72rem;
  font-weight: 700;
}

.layout-color-alpha-label {
  width: auto;
  padding: 0 0.45rem;
  justify-content: flex-start;
}

.layout-color-channel,
.layout-color-alpha {
  width: 100%;
  accent-color: #4f46e5;
  cursor: pointer;
}

.layout-color-channel {
  width: 72px;
  height: 34px;
  padding: 0 0.45rem;
  border: 1px solid #d1d5db;
  border-radius: 0.55rem;
  color: #374151;
  text-align: center;
}

.layout-color-channel-value,
.layout-color-alpha-value {
  font-size: 0.75rem;
  color: #6b7280;
  text-align: right;
}

@media (max-width: 768px) {
  .layout-color-picker-row {
    align-items: flex-start;
  }
}
</style>
